// Import the necessary functions from the SDKs you need
import { config } from "dotenv";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"; // Import the auth function
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
config(); // This will load the environment variables from .env.local

// Rest of your firebase.js code...

const firebaseConfig = {
  apiKey: "AIzaSyAbQi2PRBB-yQADTIPsSSnDlcrbFbOIMqA",
  authDomain: "subsidyscheme-c6b71.firebaseapp.com",
  projectId: "subsidyscheme-c6b71",
  storageBucket: "subsidyscheme-c6b71.firebasestorage.app",
  messagingSenderId: "43395338488",
  appId: "1:43395338488:web:0ecf9a43f4ef67564dab0d",
  measurementId: "G-RJTKWX6G9B"
};

// Initialize Firebase
let app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
const auth = getAuth(app);
const storage = getStorage(app);
const db = getFirestore(app);
export { app, auth, db, storage };

